<template>
    <div class="wrapper">
        <CCHeader></CCHeader>
        <div class="data-wrapper">
            <CCSideBar></CCSideBar>                        
            <div class="main">
                <div class="report">
                <div class="report-filters">
                    <div class="filter-wrap">
                        <CCCalendar @apply="this.setDateRanges" :comparable="false" :excludable="false" :periods="[dates]"></CCCalendar>
                    </div>
                </div>
                </div>
                <div class="first">
                    <Table
                        :name="Tables.OVERALL_TARGETS"
                        :columns="tableColumns(Tables.OVERALL_TARGETS)"
                        :body="tableRows(Tables.OVERALL_TARGETS)"
                        :footer="tableFooter(Tables.OVERALL_TARGETS)"
                        :status="tableStatus(Tables.OVERALL_TARGETS)"
                    />
                </div>
                <div class="first">
                    <Table
                        :name="Tables.YAHOO_ARBITRAGE"
                        :columns="tableColumns(Tables.YAHOO_ARBITRAGE)"
                        :body="tableRows(Tables.YAHOO_ARBITRAGE)"
                        :footer="tableFooter(Tables.YAHOO_ARBITRAGE)"
                        :status="tableStatus(Tables.YAHOO_ARBITRAGE)"
                    />
                </div>
                <div class="reports">
                    <div class="flex-reports">
                        <Table
                            :name="Tables.OVERPAYMENT"
                            :columns="tableColumns(Tables.OVERPAYMENT)"
                            :body="tableRows(Tables.OVERPAYMENT)"
                            :footer="tableFooter(Tables.OVERPAYMENT)"
                            :status="tableStatus(Tables.OVERPAYMENT)"
                        />
                        <Table
                            :name="Tables.THIRD_PARTIES"
                            :columns="tableColumns(Tables.THIRD_PARTIES)"
                            :body="tableRows(Tables.THIRD_PARTIES)"
                            :footer="tableFooter(Tables.THIRD_PARTIES)"
                            :status="tableStatus(Tables.THIRD_PARTIES)"
                        />
                    </div>
                </div>
                <div class="reports">
                    <div class="flex-reports">
                       
                        <Table
                            :name="Tables.DIVERSIFICATION"
                            :columns="tableColumns(Tables.DIVERSIFICATION)"
                            :body="tableRows(Tables.DIVERSIFICATION)"
                            :footer="tableFooter(Tables.DIVERSIFICATION)"
                            :status="tableStatus(Tables.DIVERSIFICATION)"
                        />                    
                        <Table
                            :name="Tables.PUSH_NOTIFICATIONS"
                            :columns="tableColumns(Tables.PUSH_NOTIFICATIONS)"
                            :body="tableRows(Tables.PUSH_NOTIFICATIONS)"
                            :footer="tableFooter(Tables.PUSH_NOTIFICATIONS)"
                            :status="tableStatus(Tables.PUSH_NOTIFICATIONS)"
                        />                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import '@/style/reports/base_report_style.scss';    

    import QueryBuilder from '@/graphql/QueryBuilder';
    import lodash from 'lodash';

    import CCHeader from '@/components/common/CCHeader';
    import CCSideBar from '@/components/common/CCSideBar';
    import {reportColumnsDefinitions as orverallTargetsColumns} from '../configs/target/overall_targets';
    import {reportColumnsDefinitions as defaultTargetsColumns} from '../configs/target/default';
    import {reportColumnsDefinitions as orverpaymentTargetsColumns} from '../configs/target/overpayment';
    
    import {Tables} from '../configs/target/constants';
    import moment from 'moment';    

    import CCCalendar from '@/components/common/calendar/v2/Calendar';

    import { LineScalePulseOutRapidLoader as LineScaleLoader } from 'vue-loaders';

    import Table from '@/components/reports/targetReport/table';

    export default {
        name: "target-report",
        components: {
            CCHeader,
            CCSideBar,
            Table,
            CCCalendar
        },

        data(){
            return {
                namespace: 'targetReport',
                rows: {},
                footer: {},
                status : {},
                Tables: Tables,
                orverallTargetsColumns: orverallTargetsColumns,
                orverpaymentTargetsColumns: orverpaymentTargetsColumns,
                defaultTargetsColumns: defaultTargetsColumns,
                dates: {
                    start: moment().add(-7, 'days'),
                    end: moment().add(-1, 'days'),
                }
            }
        },

        beforeMount() {

            if( this.$route.query.hasOwnProperty('startDate') ) {
                this.dates.start = moment(this.$route.query.startDate);
            }

            if( this.$route.query.hasOwnProperty('endDate') ) {
                this.dates.end = moment(this.$route.query.endDate);
            }
        },

        methods: {

            setDateRanges(datePeriods){
                let startDate = datePeriods[0].start;
                let endDate   = datePeriods[0].end;
                if( 
                    this.dates.start.format('YYYY-MM-DD') === startDate.format('YYYY-MM-DD') && 
                    this.dates.end.format('YYYY-MM-DD') === endDate.format('YYYY-MM-DD') 
                ) {
                    return;
                }
                
                this.dates.start = startDate;
                this.dates.end   = endDate;

                this.$router.replace({query: {
                    startDate : startDate.format('YYYY-MM-DD'),
                    endDate : endDate.format('YYYY-MM-DD'),
                }});

                for(let key in this.status) {
                    this.status[key] = 'empty';
                }
            }, 

            tableColumns(table) {
                switch(table) {
		            case this.Tables.YAHOO_ARBITRAGE:
                    case this.Tables.OVERALL_TARGETS:
                        return this.orverallTargetsColumns;
                        break;

                    case this.Tables.OVERPAYMENT:
                    case this.Tables.THIRD_PARTIES:
                    case this.Tables.DIVERSIFICATION:
                        return this.orverpaymentTargetsColumns;
                        break;

                    default:
                        return this.defaultTargetsColumns;
                        break;
                }
            },
        
            tableStatus(table) {
                return this.status[table] || 'empty';
            }, 
            
            tableRows(table) {

                if( this.tableStatus(table) === 'empty') {
                    this.loadTableData(table);
                }

                if( this.tableStatus(table) !== 'loaded') {
                    return [];
                }

                return this.rows[table] || [];
            },

            tableFooter(table) {
                return this.footer[table] || [];
            },

            loadTableData(table) {
                this.$set(this.status, table, 'loading');

                let self        = this;
                let qb          = new QueryBuilder();
                let reportQuery = qb.connection('targetReport')
                    .fields(`
                        days {
                            date
                            target
                            target125
                            target150
                            targetTarget
                            targetStretch
                            actual
                            difference
                        }
                        total {
                            target
                            actual
                            target125
                            target150
                            targetTarget
                            targetStretch
                            difference
                        }
                        average {
                            target
                            target125
                            target150
                            targetTarget
                            targetStretch
                            actual                            
                            difference
                        }
                    `)
                    .args({ filters : {
                        dateInRange: [self.dates.start.format('YYYY-MM-DD'), self.dates.end.format('YYYY-MM-DD')],
                        targetName: table
                    }}) 
                    .query()
                    .fetch(function(result){
                        function normalizeRow(row) {
                            if( row.hasOwnProperty('date') ) {               
                                row.date = moment(row.date).format('DD/MM ddd');
                            }

                            row.targetTarget  = parseInt(row.targetTarget);
                            row.targetStretch = parseInt(row.targetStretch);
                            row.target        = parseInt(row.target);
                            row.target125     = parseInt(row.target125);
                            row.target150     = parseInt(row.target150);
                            row.actual        = parseInt(row.actual);
                            row.difference    = parseInt(row.difference);

                            return row;
                        }

                        let rows     = [];
                        let footer   = [];
                        if( lodash.isArray(result.days) ) {
                            for( let key in result.days ) {
                                if( ! result.days.hasOwnProperty(key) ) continue;
                                let row = result.days[key];         
                                row = normalizeRow(row);
                                rows.push(row);
                            }
                        }

                        self.$set(self.rows, table, rows);

                        if( lodash.isObject(result.total) && result.total !== null ) {
                            let row = normalizeRow(result.total);
                            row.date = 'Total';
                            footer.push(row);
                        }

                        if( lodash.isObject(result.average) &&  result.total !== null  ) {
                            let row = normalizeRow(result.average);
                            row.date = 'Average';
                            footer.push(row);
                        }

                        if( footer.length > 0 ) {
                            self.$set(self.footer, table, footer);
                        }
                    })
                    .catch(function (errorResponse) {
                        let message = [];
                        if( errorResponse.hasOwnProperty('errors') ) {
                            errorResponse.errors.forEach(function (error) {
                                message.push(error.message);
                            })
                        } else {
                            message.push(errorResponse.message);
                        }

                        self.$notification.showWarning({
                            title: 'API Error',
                            message: message.join("<br/>"),
                            timeout: 10000
                        });
                    })
                    .finally(function(){
                        self.$set(self.status, table, 'loaded');
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        flex-direction: column;
        width:100%;
    }

    .report {
        height: auto;
    }

    .reports {
        display: block;        
    }

    .flex-reports {
        display:flex;

        .report {
            padding-left: 0px;
        }

        .report:first-child {
            padding-left: 20px;
        }

        @media (max-width : 1280px) {
            flex-direction: column;
            .report {
                padding-left: 20px;
            }
        }

        @include mobile-only {
            .report {
                padding-left: 0px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TargetReport.vue